/*
 * Copyright (c) Nexign, JSC, 2025.
 */

/**
 * Product card component
 *
 * @author Nikolay Sviridov
 * @version 1.39.0
 * @since 1.39.0
 */

import ArrowTooltip from '@components/common/Tooltip/Tooltip';
import { IPageProductsTranslation } from '@modules/internationalization/types/pages/products';
import {
    ProductCardTariffFieldInternetUnlimitedStyled,
} from '@pages/PageProducts/components/ProductCards/styled/ProductCardTariffStyled';
import ProductCardTariffField from '@pages/PageProducts/components/ProductCards/Tariff/ProductCardTariffField';
import {
    checkCommaAfterThisInternetLimited,
} from '@pages/PageProducts/components/ProductCards/utils/rateplanCardUtils';
import { IProductCardTariffField } from '@pages/PageProducts/tariffsAndServicesProductTariffTypes';

interface IProductCardInternetLimited {
    cardTranslation: IPageProductsTranslation['campaignTariffsCard'],
    internetLimited?: IProductCardTariffField<string[]>;
}

export const ProductCardInternetLimited = (props: IProductCardInternetLimited) => {
    const { cardTranslation, internetLimited } = props;

    if (!internetLimited) {
        return null;
    }

    return (
            // Бесплатный интернет-трафик:
            internetLimited && <ProductCardTariffField title={internetLimited.title}>
            <ProductCardTariffFieldInternetUnlimitedStyled>
                {
                    internetLimited.value.map((value: string, index: number) => (
                        cardTranslation.internetLimited[value] && (
                            cardTranslation.internetLimited[value].tooltip
                                ? <ArrowTooltip
                                    key={value}
                                    message={cardTranslation.internetLimited[value].tooltip}
                                    placement="top"
                                >
                                    <div>
                                        {cardTranslation.internetLimited[value].label}
                                        {
                                            checkCommaAfterThisInternetLimited(
                                                index,
                                                cardTranslation,
                                                internetLimited,
                                            )
                                        }
                                    </div>
                                </ArrowTooltip>
                                : <div key={value}>
                                    {cardTranslation.internetLimited[value].label}
                                    {
                                        checkCommaAfterThisInternetLimited(
                                            index,
                                            cardTranslation,
                                            internetLimited,
                                        )
                                    }
                                </div>
                        )
                    ))
                }
            </ProductCardTariffFieldInternetUnlimitedStyled>
        </ProductCardTariffField>
    )
}
